import axios from "../axios";

// Get Captcha API
export const getCaptchaService = () => {
  return axios.get("https://toolkit.opt4solution.site/api/Captcha/GetCaptcha", {
    params: {
      hexColor: "#249CED", 
    },
  });
};